import React from 'react'
import useSearchParams from '../../../hooks/useSearchParams'
import Alert from '../../molecules/Alert'

const PasswordResetMessages = () => {
  const searchParams = useSearchParams()
  let message = ''

  if (searchParams.has('password_instructions')) {
    message = 'Recibirás un email con instrucciones para restaurar su clave.'
  } else if (searchParams.has('password_changed')) {
    message = 'Su clave cambió correctamente.'
  }

  return (
    <div className="mb-4">
      {message && (
        <Alert showClose type="success">
          {message}
        </Alert>
      )}
    </div>
  )
}

export default PasswordResetMessages
